<template>
  <div class="homeBox">
    <navigation class="navigation"></navigation>
    <div class="right">
      <div class="unionTitle">
        <div class="breadcrumb">
          <Breadcrumb>
            <BreadcrumbItem to="/homeContent">
              <img key="" alt="home" class="homeicon" src="../../assets/photo/home.png"/>首页
            </BreadcrumbItem>
            <BreadcrumbItem
              v-for="(item, index) in breadcrumbList"
              :key="index + 'BreadcrumbItem'"
              :to="jumpTo(item)"
            >
              {{ item.meta.title || "" }}
            </BreadcrumbItem>
          </Breadcrumb>
        </div>
        <div class="titleright">
          <div style="height: 20px;margin-right: 10px;">
            <Tooltip placement="bottom-start" theme="light">
              <Avatar v-if="personalImg" class="userImg" icon="ios-person" size="large"/>
              <Avatar v-else :src="this.personal.imgPath" class="userImg" size="large"/>
              {{ personal.nikeName }}
              <div slot="content" class="tooltipTitle">
                <p @click="goto('personal')">个人资料</p>
                <p @click="goto('password')">修改密码</p>
              </div>
            </Tooltip>
          </div>
          <div @click="goOut">
            <Tooltip content="退出登录">
              <img
                alt="logout"
                src="../../assets/photo/logout.png"
                style="width: 20px; height: 20px;margin-left:15px"
              />
            </Tooltip>
          </div>
        </div>
      </div>
      <div class="table">
        <div class="showTable">
          <router-view/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {logout} from '@/api/login.js'
import {loginProfile} from "@/api/login";

export default {
  name: "homePage",
  components: {
    navigation: () => import("@/views/home/tableMenu"),
  },
  data() {
    return {
      personalImg: true,
      personal: {
        telephone: "",
        nikeName: "",
        imgPath: "",
      },
      breadcrumbList: [
        {path: "/homeContent", name: "homeContent", meta: {title: "首页"}},
      ],
      // breadcrumbList: []
    };
  },
  watch: {
    $route() {
      this.getBreadcrumb();
    },
    $router() {
      this.getBreadcrumb();
    },
  },
  created() {
    this.getBreadcrumb();
  },
  mounted() {
    // document.onkeydown = function(e){
    //   let key = window.event.keyCode
    //   if (key === 13){
    //     e.preventDefault()
    //   }
    // }
    loginProfile().then(res => {
      this.personal = res.data.data
      localStorage.setItem('peopleName', res.data.data.nikeName)
      localStorage.setItem('peopleTel', res.data.data.telephone)
      localStorage.setItem('peopleOrgid', res.data.data.orgId)
      if (this.personal.imgPath) {
        this.personal.imgPath = res.data.data.imgPath
        this.personalImg = false
      } else {
        this.personalImg = true
      }
    })
  },
  methods: {
    jumpTo(item) {
      if (item.path.split("/").slice(1).length === 2) {
        return item.path;
      }
    },
    goto(val) {
      this.$router.push({name: val});
    },
    //退出
    goOut() {
      this.$Modal.confirm({
        title: "确认退出？",
        onOk: () => {
          logout().then((res) => {
            this.$Message.success(res.data.msg);
            this.$router.push({name: "login"});
          })
            .catch(() => {
              this.$Message.error("退出失败");
            });
        },
        onCancel: () => {
          this.$Message.info("已取消退出");
        },
      });
    },
    getBreadcrumb() {
      let paramsList = [];
      paramsList = this.$route.path.split("/").slice(1);
      let routerList = [];
      let num = 0;
      if (paramsList[0] === "personal") {
        routerList.push(this.$route.matched[1]);
      }
      if (paramsList[0] === "addEnterprise") {
        routerList.push(this.$route.matched[1]);
      }
      if (paramsList[0] === "password") {
        routerList.push(this.$route.matched[1]);
      }
      if (paramsList[0] !== "homeContent") {
        const fn = (params) => {
          if (typeof params === "string") {
            this.$router.options.routes.forEach((item) => {
              if (item.name === params) {
                routerList.push(item);
                num = num + 1;
                if (item.children) {
                  fn(item.children);
                }
              }
            });
          } else {
            params.forEach((item) => {
              if (
                paramsList[num] ===
                item.path.split("/").slice(1)[
                item.path.split("/").slice(1).length - 1
                  ]
              ) {
                routerList.push(item);
                num++;
                if (item.children) {
                  fn(item.children);
                }
              }
            });
          }
        };
        fn(paramsList[0]);
      }
      this.breadcrumbList = routerList;
    },
  },
};
</script>

<style lang="less" scoped>
html, body {
  // overflow: hidden;
  overflow-x: hidden !important;
  overflow-y: hidden !important;
}

.userImg {
  width: 30px;
  height: 30px;
  line-height: 30px;
}

.homeBox {
  background-color: #f9faff;
  display: flex;
  width: 100%;
  height: 100%;

  .navigation {
    width: 220px;
    height: 100%;
  }

  .right {
    width: calc(100% - 220px);
    margin-left: 10px;

    .unionTitle {
      width: 100%;
      height: 80px;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      background-color: #fff;

      .breadcrumb {
        width: 600px;
        height: 50px;
        line-height: 50px;
        font-size: 18px;
        padding-left: 28px;
        font-weight: 400;
        display: flex;
        flex-direction: row;
        // color: #303133;
        .homeicon {
          width: 20px;
          height: 20px;
          transform: translateY(5px);
        }
      }

      & /deep/ .ivu-breadcrumb a {
        cursor: pointer;
        font-weight: bold;
      }

      .titleleft {
        display: flex;
        flex-direction: row;
        margin-left: 30px;

        p {
          font-size: 16px;
          color: #000;
        }
      }

      .titleright {
        margin-right: 15px;
        display: flex;
        flex-direction: row;
        cursor: pointer;

        .system {
          width: 25px;
          height: 25px;
          margin-right: 20px;
          transform: translateY(-3px);
        }
      }
    }

    .table {
      min-height: calc(100% - 80px);
      max-height: calc(100% - 80px);
      background-color: #fff;
      overflow-y: auto;
      margin-top: 10px;

      .showTable {
        padding: 20px 30px 40px 30px;
        margin-bottom: 30px;
      }
    }
  }
}
</style>
